import React, { useState } from 'react';
import axios from 'axios';
import API_URL from '../config';

function QuickDeliveryModal({ onClose, onSuccess, order, customerName }) {
  const [quantity, setQuantity] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/add-delivery`, {
        customer_id: order.customer_id,
        quantity: parseFloat(quantity),
        delivery_person_id: localStorage.getItem('userId'),
        order_id: order.id
      });
      
      if (response.data.message) {
        alert(response.data.message);
      }
      
      onSuccess();
      onClose();
    } catch (err) {
      alert('Error adding delivery: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Make Delivery Against Order</h2>
        <div className="order-info">
  <p><strong>Customer:</strong> {order.customer?.name || customerName}</p>
  <p><strong>Ordered Quantity:</strong> {order.ordered_quantity} kg</p>
  <p><strong>Already Delivered:</strong> {order.delivered_quantity || 0} kg</p>
  <p><strong>Remaining:</strong> {(order.ordered_quantity - (order.delivered_quantity || 0))} kg</p>
</div>
        <form onSubmit={handleSubmit}>
          <input 
            type="number" 
            step="0.01" 
            placeholder="Delivery Quantity (kg)" 
            value={quantity} 
            onChange={(e) => setQuantity(e.target.value)} 
            required 
            autoFocus
          />
          <small>Note: Order will be marked as COMPLETED after this delivery</small>
          <div className="modal-buttons">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit" disabled={loading}>{loading ? 'Recording...' : 'Record Delivery'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default QuickDeliveryModal;